import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import getIncludedResource from '../../../helpers/getIncludedResource';
import { isBroker, isOwner } from '../../auth/redux/authActions';
import { BackButton, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import UserDetails from '../components/UserDetails/UserDetails';
import UserRoles from '../components/UserRoles/UserRoles';
import UserNotes from '../components/UserNotes/UserNotes';
import UserAudit from '../components/UserAudit';
import { getUserOrganisationRoles, getUser } from '../redux/userActions';

const isInOwnerOrganisation = (resource) => {
  const organisations = getIncludedResource(
    resource.data,
    resource.included,
    'organisations',
  );
  let isOwner = false;

  if (organisations) {
    organisations.forEach((organisation) => {
      if (organisation.attributes.organisation_type_name === 'Owner') {
        isOwner = true;
      }
    });
  }

  return isOwner;
};
const UserShowContainer = ({ params: { id }, onGetUser, onGetUserOrganisationRoles }) => {
  const [activeTab, setActiveTab] = useState();
  useEffect(
    () => {
      onGetUser(id, [
        'notes',
        'roles',
        'organisation_roles',
        'available_products',
        'current_broker',
        'current_organisation.channel_access',
        'organisations',
      ]);
      onGetUserOrganisationRoles(id);
    },
    [id, onGetUser, onGetUserOrganisationRoles],
  );

  const handleTab = (key) => {
    setActiveTab(key);
  };

  const resource = useSelector((state) => state?.user?.resources?.[id]);
  const organisationRoles = useSelector(
    (state) => state?.user?.organisationRoles?.data?.meta,
  );

  const contact = resource?.data?.attributes?.status === 'contact';

  if (!resource) {
    return (
      <InternalContainer title={contact ? 'Contact' : 'User'} buttons={<BackButton />}>
        <Loader />
      </InternalContainer>
    );
  }
  const isOwnerOrg = isInOwnerOrganisation(resource);

  return (
    <InternalContainer title={contact ? 'Contact' : 'User'} buttons={<BackButton />}>
      <Tabs
        activeKey={activeTab}
        id="user-tabs"
        unmountOnExit={true}
        onSelect={handleTab}
      >
        <Tab eventKey={1} title="Details">
          <UserDetails resource={resource} isInOwnerOrganisation={isOwnerOrg} />
        </Tab>

        {!contact && (
          <Tab eventKey={2} title="Organisation Roles">
            <UserRoles resource={resource} organisationRoles={organisationRoles} />
          </Tab>
        )}

        {!isBroker() && !contact && (
          <Tab eventKey={3} title="Notes">
            <UserNotes resource={resource} />
          </Tab>
        )}

        {isOwner() && (
          <Tab eventKey={4} title="Audit">
            <UserAudit resource={resource} />
          </Tab>
        )}
      </Tabs>
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    onGetUser: getUser,
    onGetUserOrganisationRoles: getUserOrganisationRoles,
  },
)(UserShowContainer);
